enum SmsCountry {
  CA = 'CA',
  US = 'US',
}

enum VerificationStep {
  SelectVerificationProvider = 'SelectVerificationProvider',
  EnterPhoneNumber = 'EnterPhoneNumber',
  EnterDisableSmsCode = 'EnterDisableSmsCode',
  EnterSmsCode = 'EnterSmsCode',
  OtpQrCode = 'OtpQrCode',
  ConfirmDisableOtpCode = 'ConfirmDisableOtpCode',
  ConfirmOtpCode = 'ConfirmOtpCode',
  SelectDisabler = 'SelectDisabler',
}

export { SmsCountry, VerificationStep };
